import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import UserContext from "./lib/contexts/UserContext";
import HospitalDoctorContext from "./lib/contexts/HospitalDoctorContext";
import { FeatureFlagProvider } from "./lib/contexts/FeatureFlagContext";
import { TVConfigurationProvider } from "./lib/contexts/TVConfigurationContext";
import { ToastContainer } from "react-toastify";

import "./App.css";
import "react-dropdown/style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <UserContext>
        <HospitalDoctorContext>
        <TVConfigurationProvider>
          <FeatureFlagProvider>
            <ToastContainer />
            <AppRoutes />
          </FeatureFlagProvider>
        </TVConfigurationProvider>
        </HospitalDoctorContext>
      </UserContext>
    </BrowserRouter>
  );
}

export default App;
